import { RegionSettlementsContainer } from '@/modules/Regions';

const RegionSettlements = (): JSX.Element => <RegionSettlementsContainer />;

export default RegionSettlements;
